// extracted by mini-css-extract-plugin
module.exports = {"video-player":"VideoPlayer_video-player__f9MAg"};